import React, { useState, useEffect } from "react";
import "./style.css";
import axios from "axios";
import Pusher from "pusher-js";
import { useLocation } from "react-router-dom";
import HeaderImage from "../../assets/header.svg";

function Display() {
  const [data, setData] = useState([]);
  const [onCalling, setOnCalling] = useState(false);
  const [onPanggilAntrianData, setOnPanggilAntrianData] = useState(null);

   const playing = async (url) => {
    await new Promise((resolve) => {
      const audio = new Audio(url);
      audio.onended = resolve;
      audio.play();
    });
  };
  
  const location = useLocation();

  const getAntrian = async (tenantIds) => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}/antrian-display`
      );
      const filteredResult = result.data.filter((e) =>
        tenantIds.includes(e.layanan_id)
      );
      setData(filteredResult);
    } catch (err) {
      console.log("error : ", err);
    }
  };

  const [pusher, setPusher] = useState(null);

  const [tenantIds, setTenantIds] = useState([]);
  useEffect(() => {
    const tenantIdsFromParams = location.search
      ? new URLSearchParams(location.search)
          .get("id")
          .split(",")
          .map((e) => parseInt(e))
      : [];
    getAntrian(tenantIdsFromParams);
    setTenantIds(tenantIdsFromParams);
    setPusher(
      new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
        cluster: process.env.REACT_APP_PUSHER_CLUSTER,
      })
    );
  }, []);

  const startPusherPanggilAntrian = () => {
    console.log("Start Pusher Panggil Antrian");
    const pusherChannel = pusher.subscribe("panggiAntrian");
    setChannelSubscribed((prevState) => ({
      ...prevState,
      panggilAntrian: true,
    }));
    pusherChannel.bind("panggil_antrian", (incomingData) => {
      console.log(tenantIds.includes(incomingData.layanan_id), onCalling);
      if (tenantIds.includes(incomingData.layanan_id) && !onCalling) {
        setOnPanggilAntrianData(incomingData);
      }
    });
  };

  const [channelSubscribed, setChannelSubscribed] = useState({
    panggilAntrian: false,
    setAntrian: false,
  });

  useEffect(() => {
    if (data.length > 0 && pusher && !channelSubscribed.panggilAntrian) {
      startPusherPanggilAntrian();
    }
  }, [pusher, data]);

  useEffect(() => {
    if (onPanggilAntrianData) {
      if (onPanggilAntrianData.no_loket) {
        playing(process.env.PUBLIC_URL + "/sound/bell.wav");
        let newData = [...data];
        const targetIndex = newData.findIndex(
          (i) => i.id === onPanggilAntrianData.id
        );

        //Find new/duplicate data
        if (targetIndex === -1) {
          newData.unshift(onPanggilAntrianData);
        } else {
          //Move position to top
          const temp = newData[targetIndex];
          newData.splice(targetIndex, 1);
          newData.unshift(temp);
        }

        setData(newData);
         setOnCalling(true);
          setTimeout(() => {
            setOnCalling(false);
          }, 8000);
      } else {
        let newData = [...data];
        const targetIndex = data.findIndex(
          (e) => e.id === onPanggilAntrianData.id
        );
        newData.splice(targetIndex, 1);
        setData(newData);
      }
    }
  }, [onPanggilAntrianData]);

  const renderTable = (dataSlice, isFirsttable) => {
    const dataToShow = [0, 1, 2, 3, 4, 5, 6, 7].map((index) => {
      if (data[index]) {
        return dataSlice[index];
      }
      return index;
    });
    return (
      <table className="list" border="1">
        <thead>
          <tr>
            <th>Instansi</th>
            <th>Nama Layanan</th>
            <th>No. Antrian</th>
            <th>No. Meja</th>
          </tr>
        </thead>
        <tbody>
          {dataToShow.map((item, index) => {
            return (
              <tr
                key={item?.id ?? index + "_dummy"}
                className={
                  isFirsttable && index === 0 && onCalling ? "called" : ""
                }
              >
                <td className="logo">
                  <img src={item?.gambar_layanan} />
                </td>
                <td>{item?.nama_sub_layanan}</td>
                <td>{item?.urutan}</td>
                <td>{item?.no_loket !== "" ? item?.no_loket : "-"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };
  return (
    <main id="display">
      <div className="header_wrapper">
        <img src={HeaderImage} />
      </div>
      <div className="table_wrapper">
        {renderTable(data.slice(0, 8), true)}
        {renderTable(data.slice(8, 16), false)}
      </div>
    </main>
  );
}

Display.propTypes = {};
export default Display;
